import { jsonProperty, Serializable } from 'ts-serializable';

import { SurveyQuestionModel } from '~modules/surveys/models/SurveyQuestionModel';
import { SurveyFormTypeIdEnum } from '~modules/surveys/types/SurveyFormTypeIdEnum';

// Не пройденный опрос, модель для формирования анкеты
export class SurveyModel extends Serializable {
  @jsonProperty(String, null) headerText: string | null = null;
  @jsonProperty(String, null) carDescr: string | null = null;
  @jsonProperty(Number, null) formId: number | null = null;
  @jsonProperty(Number, null) formTypeId: SurveyFormTypeIdEnum | null = null;
  @jsonProperty([SurveyQuestionModel]) questions: SurveyQuestionModel[] = [];
}
